module.exports = __webpack_public_path__ + "img/4.160fab21.svg";